import { useEffect, useState } from "react";

export const Potree = ({ onPotreeViewerChanged, onGuiLoaded }) => {
  const [potreeViewer, setPotreeViewer] = useState(null);
  useEffect(() => {
    if (potreeViewer)
      return;
    const viewer = new window.Potree.Viewer(
      document.getElementById("potree_render_area"),
      {
        useDefaultRenderLoop: false,
      }
    );

    viewer.setEDLEnabled(false);
    viewer.setFOV(60);
    viewer.setPointBudget(10_000_000);
    viewer.setBackground("gradient");
    viewer.useHQ = false;

    viewer.loadGUI(() => {
      viewer.setLanguage("hu");
      $("#menu_appearance").next().show();
      $("#menu_tools").next().show();
      $("#menu_clipping").next().show();
      $("#menu_scene").next().show();
      $("#menu_export").next().show();
      const width = Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      );
      if (width > 500) {
        /* eslint-enable no-undef */
        viewer.toggleSidebar();
      }
      onGuiLoaded?.();
    });
    onPotreeViewerChanged?.(viewer);
    setPotreeViewer(viewer);
    return () => {
    };
  }, [onPotreeViewerChanged, onGuiLoaded, potreeViewer]);

  useEffect(() => {
    return () => {
      return potreeViewer?.renderer?.dispose();
    };
  }, [potreeViewer]);

  useEffect(() => {
    let stop = false;
    let isOrthoCamera = false;

    function loop(timestamp) {
      if (stop) return;
      window.requestAnimationFrame(loop);
      if (!potreeViewer || !potreeViewer.scene.map || !potreeViewer.scene.map.visible) return;
      if (!window.toMap) return;
      let camera = potreeViewer.scene.getActiveCamera();

      const Vector3 = window.Potree.Vector3;
      const toMap = window.toMap;
      let pPos = new Vector3(0, 0, 0).applyMatrix4(camera.matrixWorld);
      let pRight = new Vector3(600, 0, 0).applyMatrix4(camera.matrixWorld);
      let pUp = new Vector3(0, 600, 0).applyMatrix4(camera.matrixWorld);
      let pTarget = potreeViewer.scene.view.getPivot();

      const Cesium = window.Cesium;
      let toCes = (pos) => {
        let xy = [pos.x, pos.y];
        let height = pos.z;
        let deg = toMap.forward(xy);
        let cPos = Cesium.Cartesian3.fromDegrees(...deg, height);

        return cPos;
      };

      let cPos = toCes(pPos);
      let cUpTarget = toCes(pUp);
      let cTarget = toCes(pTarget);

      let cDir = Cesium.Cartesian3.subtract(
        cTarget,
        cPos,
        new Cesium.Cartesian3()
      );
      let cUp = Cesium.Cartesian3.subtract(
        cUpTarget,
        cPos,
        new Cesium.Cartesian3()
      );

      cDir = Cesium.Cartesian3.normalize(cDir, new Cesium.Cartesian3());
      cUp = Cesium.Cartesian3.normalize(cUp, new Cesium.Cartesian3());

      const cesiumViewer = window.cesiumViewer;
      if (!cesiumViewer) return;
      cesiumViewer.camera.setView({
        destination: cPos,
        orientation: {
          direction: cDir,
          up: cUp,
        },
      });

      if (camera.type === "OrthographicCamera") {
        if (!isOrthoCamera) {
          cesiumViewer.camera.switchToOrthographicFrustum();
          isOrthoCamera = true;
        }
        cesiumViewer.camera.frustum.aspectRatio =
          cesiumViewer.scene.drawingBufferWidth /
          cesiumViewer.scene.drawingBufferHeight;
        cesiumViewer.camera.frustum.width = camera.right - camera.left;
      } else {
        if (isOrthoCamera) {
          cesiumViewer.camera.switchToPerspectiveFrustum();
          isOrthoCamera = false;
        }
        let aspect = camera.aspect;
        if (aspect < 1) {
          let fovy = Math.PI * (camera.fov / 180);
          cesiumViewer.camera.frustum.fov = fovy;
        } else {
          let fovy = Math.PI * (camera.fov / 180);
          let fovx = Math.atan(Math.tan(0.5 * fovy) * aspect) * 2;
          cesiumViewer.camera.frustum.fov = fovx;
        }
      }
      cesiumViewer.render();
    }

    requestAnimationFrame(loop);
    return () => {
      stop = true;
    };
  }, [potreeViewer]);

  return (
    <div
      className="potree_container"
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        left: "0px",
        top: "0px",
      }}
    >
      <div id="potree_render_area" style={{ backgroundColor: "#F1F5FB" }}>
        <div
          id="cesiumContainer"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%"
          }}
        ></div>
      </div>
      <div id="potree_sidebar_container"></div>
    </div>
  );
};
